export const formTypes = {
  b2c: 'b2c',
  b2b: 'b2b',
  contact: 'general',
  feedback: 'feedback',
  complaints: 'complaints',
}
export const formTypesNames = [
  { type: 'general', name: 'General'},
  { type: 'b2c', name: 'Tenants'},
  { type: 'b2b', name: 'Landlords'},
  { type: 'feedback', name: 'feedback'},
  { type: 'complaints', name: 'Complaints'},
]

export const messagesColor = {
  success: 'success',
  error: 'danger'
}

export const dateFormat = 'yyyy-MM-dd'

export const errorMessages = {
  apiError: 'Error sending request, please contact via email: info@satel.sa',
  fillAllTheFields: 'Please fill all the fields',
  pdfMissing: 'Please attached the PDF file',
  required: 'This field is required',
  email: 'Please enter a valid email address',
  minlength: 'Minimum length is 6 characters',
  maxlength: 'Maximum length is 10 characters',
  pattern: 'Please enter a valid email address',
  date: 'Please enter a valid date',
  number: 'Please enter a valid number',
  min: 'Minimum value is 1',
  max: 'Maximum value is 100',
}

export const loaderMessages = {
  message: 'Sending message...'
}

export const contactFormSubjectList: string[] = [
  'General Inquiry', 'PR Request', 'Other'
]

export const pages = {
  aboutUs: 'about-Us',
  services: 'our-Services',
  leasingAndRental: 'leasing-and-rental',
  b2bPage: 'b2b-page',
  assetsAndPropertyManagement: 'assets-and-property-management',
  contactUs: 'contact-us',
  careers: 'careers',
  ourTeam: 'our-team',
  privacyPolicy: 'privacy-policy',
  termsAndConditions: 'terms-and-conditions',
}

export const components = {
  navigation: 'navigation',
  headerNote: 'header-note',
  commonTexts: 'common-texts',
  forms: 'forms',
  filters: 'filters',
}
